import React, { ComponentProps, forwardRef } from 'react';

import cn from 'classnames';

import './Input.scss';

type InputProps = ComponentProps<'input'>;

const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ type, className, disabled, ...otherProps }, ref) => (
    <input
      {...otherProps}
      ref={ref}
      type={type || 'text'}
      disabled={disabled}
      className={cn('input', className, { disabled })}
    />
  ),
);

export default Input;
